import * as React from 'react';
import { UserInfo } from '@vcd-ecm-ui/Common';
import { useSelector, useDispatch } from 'react-redux';
import { getUserInfo } from './state/user-hook-actions';
import { RootState } from '../../store/reducers';

const useUser = (): [UserInfo, () => void] => {
  const [userInfo, setUserInfo] = React.useState(null);
  const userInfoState = useSelector((state: RootState) => state.user.userInfo);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!userInfo) {
      dispatch(getUserInfo());
    }
  }, []);

  if (userInfoState && !userInfo) {
    setUserInfo(userInfoState);
  }

  const reloadUserInfo = (): void => {
    setUserInfo(null);
    dispatch(getUserInfo());
  };

  return [userInfo, reloadUserInfo];
};

export default useUser;
